import styled from 'styled-components';

export const CenteredTextContainer = styled.div`
  margin-top: 2rem;
  p {
    text-align: center !important;
  }
`;
